import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    feedData: null,
    userMessage: '',
  },
  getters: {
    game: (state) => {
      if (state.feedData) {
        return state.feedData.BettingOffer.League[0].Event;
      } else {
        return null;
      }
    }
  },
  mutations: {
    SAVE_FEED (state, payload) {
      state.feedData = payload;
    },
    SET_USERMESSAGE(state, message) {
      state.userMessage = message;
    },
  },
  actions: {
    fetchFeed (context, feedUrl) {
      return new Promise((resolve, reject) => {
        axios.get(feedUrl)
          .then((res) => {
            if (res.status === 200) {
              context.commit('SAVE_FEED', res.data)
              resolve(res.data);
            }
          })
          .catch(e => {
            console.log(e);
            reject(e);
          });
      });
    }
  }
})
